import { useEffect } from "react"
import { useAppflow } from "app/hooks/useAppFlow"
import { CarEnum } from "app/pages/appFlow/types"
import { useSelector } from "react-redux"
import { getFormFieldData } from "state/form/selectors"
import { getAppLocale } from "state/app/selectors"
import Heading from "app/components/Heading"
import { useTranslate } from "hooks/translate"
import { StyledIframe } from "../../style"

const ENGINE_POWER = 211
const FUEL_TYPE = 4
const MAKE = "POLESTAR"
const MERCHANT_ID = "K1J0P8"
const VEHICLETYPE = "A"

const getCurrentDateFormatted = () => {
  const today = new Date()
  const dd = String(today.getDate()).padStart(2, "0")
  const mm = String(today.getMonth() + 1).padStart(2, "0")
  const yyyy = today.getFullYear()

  return `${dd}${mm}${yyyy}`
}

const Step4: React.FC = () => {
  const { t } = useTranslate()
  const preferredLanguage = useSelector(getFormFieldData("language"))
  const appLocale = useSelector(getAppLocale)
  const { carType } = useAppflow()

  const CAR_MODEL = useSelector(getFormFieldData("carModel"))
    ?.toString()
    .toUpperCase()

  const INSURANCE_PURPOSE_CODE = carType === CarEnum.New ? 1 : 2
  const REGISTRATION_DATE = getCurrentDateFormatted()
  const PURCHASE_PRICE = useSelector(
    getFormFieldData("grossInvestmentAmount")
  ) as string

  useEffect(() => {
    const KBC_CAR_INSURANCE_WIDGET_SIZE_EVENT = "kbc-car-insurance-widget-size"
    const KBC_CAR_INSURANCE_WIDGET_URL_EVENT =
      "kbc-car-insurance-widget-navigate-to-url"
    const KBC_DOMAIN = ".kbc.be"
    const CBC_DOMAIN = ".cbc.be"
    const BXL_DOMAIN = ".kbcbrussels.be"

    const handleMessage = (event: MessageEvent) => {
      if (
        event.origin.endsWith(KBC_DOMAIN) ||
        event.origin.endsWith(CBC_DOMAIN) ||
        event.origin.endsWith(BXL_DOMAIN)
      ) {
        if (
          event.data?.messageType === KBC_CAR_INSURANCE_WIDGET_SIZE_EVENT &&
          event.data?.size?.height != null
        ) {
          const height = event.data.size.height
          const element = document.getElementById("kbc-car-insurance-widget")
          if (element) {
            element.style.height = height + "px"
          }
        }
        if (
          event.data?.messageType === KBC_CAR_INSURANCE_WIDGET_URL_EVENT &&
          event.data?.url != null
        ) {
          window.open(event.data.url)
        }
      }
    }

    window.addEventListener("message", handleMessage)

    return () => {
      window.removeEventListener("message", handleMessage)
    }
  })

  return (
    <>
      <Heading>{t("system.product.insurance.step4.title")}</Heading>
      <p>{t("system.product.insurance.step4.description")}</p>
      <StyledIframe
        id="kbc-car-insurance-widget"
        style={{ maxWidth: "500px" }}
        height="400"
        width="500"
        src={`https://www.kbc.be/GA0/carwidget/resources/0001/${
          preferredLanguage || appLocale
        }/?enginePower=${ENGINE_POWER}&fuelType=${FUEL_TYPE}&insurancePurposeCode=${INSURANCE_PURPOSE_CODE}&make=${MAKE}&merchantId=${MERCHANT_ID}&model=${CAR_MODEL}&purchasePrice=${PURCHASE_PRICE}&registrationDate=${REGISTRATION_DATE}&vehicleType=${VEHICLETYPE}#/car-widget/simulation`}
      >
        Your browser does not support iframes.
      </StyledIframe>
    </>
  )
}

export default Step4
